module.exports = __webpack_public_path__ + "assets/img/Business_img3.b12672ab.png";